import { render, staticRenderFns } from "./model.vue?vue&type=template&id=59040a10&"
import script from "./model.vue?vue&type=script&lang=js&"
export * from "./model.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59040a10')) {
      api.createRecord('59040a10', component.options)
    } else {
      api.reload('59040a10', component.options)
    }
    module.hot.accept("./model.vue?vue&type=template&id=59040a10&", function () {
      api.rerender('59040a10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tx/model.vue"
export default component.exports